<template>
  <div class="basicInformation">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.ReportsDetail.GENERAL_INFORMATION') }}
    </div>
    <div class="basicInf-con">
      <ul>
        <li>
          <span class="basicInf-p1">{{
            $tc('lang.ReportsDetail.Client_Name')
          }}</span>
          <span>{{ details.ireportClientname }}</span>
        </li>
        <li>
          <span class="basicInf-p1">{{
            $tc('lang.ReportsDetail.Factory_Name')
          }}</span>
          <span>{{ details.ireportVendorname }}</span>
        </li>
        <li>
          <span class="basicInf-p1">{{
            $tc('lang.ReportsDetail.Factory_Address')
          }}</span>
          <span>{{ details.ireportVendoraddress }}</span>
        </li>
        <li>
          <span class="basicInf-p1">{{
            $tc('lang.ReportsDetail.Product_Name')
          }}</span>
          <span>{{ details.ireportProductname }}</span>
        </li>
        <li>
          <span class="basicInf-p1">{{
            $tc('lang.ReportsDetail.PO_Number')
          }}</span>
          <span>{{ details.ireportOrderid }}</span>
        </li>
        <li>
          <span class="basicInf-p1">{{
            $tc('lang.ReportsDetail.Item_Number')
          }}</span>
          <span>{{ details.ireportItemnumber }}</span>
        </li>
      </ul>
      <ul>
        <li>
          <span class="basicInf-p1">{{
            $tc('lang.ReportsDetail.Order_Quantity')
          }}</span>
          <span>{{ details.ireportProductcount }}</span>
        </li>
        <li>
          <span class="basicInf-p1">{{
            $tc('lang.ReportsDetail.Actual_Shipment_Quantity')
          }}</span>
          <span>{{ details.ireportActualcount }}</span>
        </li>
        <li>
          <span class="basicInf-p1">{{
            $tc('lang.ReportsDetail.Inspector_s')
          }}</span>
          <span>{{ details.ireportInspector }}</span>
        </li>
        <li>
          <span class="basicInf-p1">{{
            $tc('lang.ReportsDetail.Factory_Representative')
          }}</span>
          <span>{{ details.ireportVendorperson }}</span>
        </li>
        <li>
          <span class="basicInf-p1">{{
            $tc('lang.ReportsDetail.Inspection_Started_at')
          }}</span>
          <span>{{ $momentData(details.ireportInspectstartdate) }}</span>
        </li>
        <li>
          <span class="basicInf-p1">{{
            $tc('lang.ReportsDetail.Inspection_Completed_at')
          }}</span>
          <span>{{ $momentData(details.ireportInspectenddate) }}</span>
        </li>
      </ul>
    </div>
    <div class="flexImg">
      <div class="prodeImg">
        <div v-if="productPhoto == undefined"></div>
        <div v-else-if="productPhoto.length == 0"></div>
        <div v-else>
          <div class="img">
            <show-img
              :data="[productPhoto[0]]"
              :otherData="{
                mediaName: '',
                mediaType: '',
                personId: '',
                orderId: '',
                reportId: '',
                mediaDesc: '',
              }"
              :id="id"
            ></show-img>
            <p>{{ $tc('lang.ReportsDetail.Product') }}</p>
          </div>
        </div>
      </div>
      <div class="prodeImg">
        <div v-if="cleargovphoto == undefined"></div>
        <div v-else-if="cleargovphoto.length == 0"></div>
        <div v-else>
          <div class="img">
            <show-img
              :data="[cleargovphoto[0]]"
              :otherData="{
                mediaName: '',
                mediaType: '',
                personId: '',
                orderId: '',
                reportId: '',
                mediaDesc: '',
              }"
              :id="id"
            ></show-img>
            <p>{{ $tc('lang.ReportsDetail.Cleargov') }}</p>
          </div>
        </div>
      </div>
      <div class="prodeImg">
        <div v-if="factorycardphoto == undefined"></div>
        <div v-else-if="factorycardphoto.length == 0"></div>
        <div v-else>
          <div class="img">
            <show-img
              :data="[factorycardphoto[0]]"
              :otherData="{
                mediaName: '',
                mediaType: '',
                personId: '',
                orderId: '',
                reportId: '',
                mediaDesc: '',
              }"
              :id="id"
            ></show-img>
            <p>{{ $tc('lang.ReportsDetail.Factorycard') }}</p>
          </div>
        </div>
      </div>
      <div class="prodeImg">
        <div v-if="remarkphoto == undefined"></div>
        <div v-else-if="remarkphoto.length == 0"></div>
        <div v-else>
          <div class="img">
            <show-img
              :data="[remarkphoto[0]]"
              :otherData="{
                mediaName: '',
                mediaType: '',
                personId: '',
                orderId: '',
                reportId: '',
                mediaDesc: '',
              }"
              :id="id"
            ></show-img>
            <p>{{ $tc('lang.ReportsDetail.Remarkphoto') }}</p>
          </div>
        </div>
      </div>
    </div>
    <a-modal
      title="修改基本资料"
      :visible="visible"
      :maskClosable="false"
      wrapClassName="reportModal"
      @ok="handleSubmit"
      :confirmLoading="confirmLoading"
      @cancel="handleCancel"
      cancelText="取消"
      okText="确定"
      width="850px"
    >
      <a-form :form="form" @submit="handleSubmit" class="basicinf-updataForm">
        <a-form-item
          label="客户名称"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input v-decorator="['ireportClientname']" />
        </a-form-item>
        <a-form-item
          label="订单数量"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input type="number" v-decorator="['ireportOrdercount']"></a-input>
        </a-form-item>
        <a-form-item
          label="供应商名称"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input v-decorator="['ireportVendorname']"></a-input>
        </a-form-item>
        <a-form-item
          label="实际出货数量"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input type="number" v-decorator="['ireportActualcount']"></a-input>
        </a-form-item>
        <a-form-item
          label="供应商地址"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input v-decorator="['ireportVendoraddress']"></a-input>
        </a-form-item>
        <a-form-item
          label="验货员"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input v-decorator="['ireportInspector']"></a-input>
        </a-form-item>
        <a-form-item
          label="货品名称"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input v-decorator="['ireportProductname']"></a-input>
        </a-form-item>
        <a-form-item
          label="供应商代表"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input v-decorator="['ireportVendorperson']"></a-input>
        </a-form-item>
        <a-form-item
          label="订单号"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input v-decorator="['ireportOrderid']"></a-input>
        </a-form-item>
        <a-form-item
          label="验货开始时间"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input v-decorator="['ireportInspectstartdate']"></a-input>
        </a-form-item>
        <a-form-item
          label="货品款号/型号"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input v-decorator="['ireportItemnumber']"></a-input>
        </a-form-item>
        <a-form-item
          label="验货结束时间"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input v-decorator="['ireportInspectenddate']"></a-input>
        </a-form-item>
        <div class="proImgAll">
          <span>产品图片:</span>
          <div>
            <div class="proImg">
              <img src="../../../assets/image/noImg.png" />
            </div>
            <div class="proImg upload">
              <a-upload
                listType="picture-card"
                class="avatar-uploader"
                :showUploadList="false"
                :action="config.urlImg + '/hzwmj/media/fileUpload'"
                :beforeUpload="beforeUpload"
                @change="handleChange"
              >
                <!-- <img v-if="imageUrl" :src="imageUrl" alt="avatar" /> -->
                <div>
                  <a-icon :type="loading ? 'loading' : 'plus'" />
                  <div class="ant-upload-text">Upload</div>
                </div>
              </a-upload>
            </div>
          </div>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import showImg from './showImg';
import { setTimeout } from 'timers';
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}
export default {
  data() {
    return {
      id: this.$route.query.id,
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),

      loading: false,
      imageUrl: '',
    };
  },
  computed: {
    details: {
      get() {
        return this.$store.state.report.details;
      },
      set(val) {
        this.$store.commit('report/save', { details: val });
      },
    },
    productPhoto: {
      get() {
        return this.$store.state.report.imgList.productPhoto;
      },
      // set(val) {
      //   this.$store.commit('report/save', { imgList: val });
      // },
    },
    cleargovphoto: {
      get() {
        return this.$store.state.report.imgList.cleargovphoto;
      },
      // set(val) {
      //   this.$store.commit('report/save', { imgList: val });
      // },
    },
    factorycardphoto: {
      get() {
        return this.$store.state.report.imgList.factorycardphoto;
      },
      // set(val) {
      //   this.$store.commit('report/save', { imgList: val });
      // },
    },
    remarkphoto: {
      get() {
        return this.$store.state.report.imgList.remarkphoto;
      },
      // set(val) {
      //   this.$store.commit('report/save', { imgList: val });
      // },
    },
  },
  components: {
    showImg,
  },
  methods: {
    //打开修改弹窗
    showModal() {
      this.visible = true;
      setTimeout(() => {
        this.form.setFieldsValue({
          ireportClientname: this.details.ireportClientname,
          ireportVendorname: this.details.ireportVendorname,
          ireportVendoraddress: this.details.ireportVendoraddress,
          ireportProductname: this.details.ireportProductname,
          ireportOrderid: this.details.ireportOrderid,
          ireportItemnumber: this.details.ireportItemnumber,

          ireportOrdercount: this.details.ireportOrdercount,
          ireportActualcount: this.details.ireportActualcount,
          ireportInspector: this.details.ireportInspector,
          ireportVendorperson: this.details.ireportVendorperson,
          ireportInspectstartdate: this.details.ireportInspectstartdate,
          ireportInspectenddate: this.details.ireportInspectenddate,
        });
      }, 0);
    },
    handleOk() {
      this.ModalText = 'The modal will be closed after two seconds';
      this.confirmLoading = true;
      setTimeout(() => {
        this.visible = false;
        this.confirmLoading = false;
      }, 2000);
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
        }
      });
    },
    handleCancel() {
      console.log('Clicked cancel button');
      this.visible = false;
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true;
        return;
      }
      if (info.file.status === 'done') {
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, imageUrl => {
          this.imageUrl = imageUrl;
          this.loading = false;
        });
      }
    },
    beforeUpload(file) {
      console.log(file);
      // const isJPG = file.type === 'image/jpeg';
      // if (!isJPG) {
      //   this.$message.error('You can only upload JPG file!');
      // }
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isLt2M) {
      //   this.$message.error('Image must smaller than 2MB!');
      // }
      // return isJPG && isLt2M;
    },
  },
};
</script>
<style lang="less">
.basicInformation {
  .basicInf-con {
    display: flex;
    .basicInf-p1 {
      display: inline-block;
      width: 120px;
    }
    > ul {
      width: 40%;
      text-align: left;
      list-style-type: none;
      li {
        line-height: 40px;
      }
    }
    > div {
      width: 20%;
      text-align: center;
      // img {
      //   width: 60%;
      //   margin: 50px 0 10px 0;
      // }
    }
  }
}
.flexImg {
  display: flex;
}
.img {
  text-align: center;
}
.basicinf-updataForm {
  .ant-form-item {
    width: 50%;
    display: inline-block;
    .ant-form-item-label {
      text-align: left;
    }
  }
  .proImg {
    display: inline-block;
    width: 160px;
    height: 120px;
    border: 1px solid rgb(202, 202, 202);
    text-align: center;
    margin: 10px;
    overflow: hidden;
    > img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .upload {
    border: none;
    .ant-upload.ant-upload-select-picture-card {
      width: 160px;
      height: 120px;
      margin: 0;
    }
    // border: 1px dashed rgb(202, 202, 202);
    // > img {
    //   width: 50%;
    // }
    // &:hover {
    //   border: 1px dashed #1890ff;
    // };
  }
}
</style>
